import React from 'react'
import SkeletonElement from './skeletonElement'
import { Shimmer } from '..'

const SkeletonEcobookCard: React.FC = () => {
  return (
    <div className="w-full bg-white shadow-sm relative rounded p-0 overflow-hidden">
      <SkeletonElement type="card"/>
      <div className="flex p-3 gap-1 items-center w-full">
        <SkeletonElement type="cardIcon"/>
        <SkeletonElement type="title"/>
      </div>
      <div className="px-3 w-full">
        <SkeletonElement type="text"/>
        <div className="flex justify-between w-full mt-10 mb-2">
          <div className="flex gap-1 w-full">
            <SkeletonElement type="online"/>
            <SkeletonElement type="title"/>
          </div>
          <div className="flex gap-1 w-full">
            <SkeletonElement type="online"/>
            <SkeletonElement type="title"/>
          </div>
        </div>
      </div>
      <Shimmer/>
    </div>
  )
}

export default SkeletonEcobookCard